import {
  CreateCompanyPageTemplatePayload,
  UpdateCompanyPageTemplatePayload,
} from 'api/company-page-template/types';
import {
  CompanyPageTemplate,
  CompanyPageTemplateLite,
} from 'api/company-page-template/types';
import { SourceType, PageType } from 'api/page-template/types';
import { createPageTemplateHooks } from 'queries/templates';
import {
  GetPageTemplatesLightInfiniteQueryOption,
  useGetPageTemplatesLightWithScrollPagination,
} from 'queries/templates/queries';

const companyPageTemplateHooks = createPageTemplateHooks({
  pageType: PageType.Company,
  sourceType: SourceType.Meeting,
  templateType: {} as CompanyPageTemplate,
  templateLiteType: {} as CompanyPageTemplateLite,
  createPayloadType: {} as CreateCompanyPageTemplatePayload,
  updatePayloadType: {} as UpdateCompanyPageTemplatePayload,
});

export const useGetAllCompanyPageTemplatesQuery =
  companyPageTemplateHooks.useGetAllTemplatesQuery;

export const useGetCompanyPageTemplatesWithScrollPagination = (
  params: { limit?: number; search?: string } = {},
  queryOptions?: GetPageTemplatesLightInfiniteQueryOption<
    PageType.Company,
    SourceType.Meeting
  >,
) =>
  useGetPageTemplatesLightWithScrollPagination(
    PageType.Company,
    SourceType.Meeting,
    params,
    queryOptions,
  );
export const useGetCompanyPageTemplateQuery =
  companyPageTemplateHooks.useGetTemplateQuery;
export const useCreateCompanyPageTemplateMutation =
  companyPageTemplateHooks.useCreateTemplateMutation;
export const useUpdateCompanyPageTemplateMutation =
  companyPageTemplateHooks.useUpdateTemplateMutation;
export const useDeleteCompanyPageTemplateMutation =
  companyPageTemplateHooks.useDeleteTemplateMutation;
export const useUpdateCompanyPageTemplateOrderMutation =
  companyPageTemplateHooks.useUpdateTemplateOrderMutation;
export const useUpdateCompanyPageTemplateStatusMutation =
  companyPageTemplateHooks.useUpdateTemplateStatusMutation;
